import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import { LogEntriesService } from './services/log.entries.service';
import { LogEntry } from './model/log.entry';

@Injectable()
export class LogEntriesDataManager {
    constructor(private logEntriesService: LogEntriesService) {}

    public getAllByUserId(_id: string, limit: number): Observable<LogEntry[]> {
        return this.logEntriesService.getAllByUserId(_id, limit);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/log.entries.datamanager.ts